import React, { useEffect } from "react"
import { Header, Navbar, Footer, FeatureStoryNavbar } from "../index"
import { IntlProvider } from "react-intl"
import { en, zhCN, zhHK } from "../../languages"
import classnames from "classnames"
import { BackToTop } from "../index"
import "../../styles/index.scss"
import { useFeatureStories } from "../../hooks"

const langObj = {
  en: en,
  "zh-HK": zhHK,
  "zh-CN": zhCN,
}

function CheckSSL() {
  if (document.location.protocol == "http:") {
    window.location.href = window.location.href.replace("http://", "https://")
  }
}

const BaseLayout = ({
  children,
  lang = "zh-HK",
  baseSlug,
  hasFeatureStory = false,
  style,
  className,
  defaultSubMenuVisible = false,
}) => {
  const isLangEN = lang === "en"
  const featureStories = useFeatureStories()

  useEffect(() => {
    // CheckSSL()
  }, [])

  return (
    <>
      <div
        className={classnames({
          "base-layout": true,
          "base-layout--en": isLangEN,
        })}
      >
        <div className="base-layout__header">
          <Header baseSlug={baseSlug}></Header>
        </div>
        <div className="base-layout__navbar">
          <Navbar
            defaultSubMenuVisible={defaultSubMenuVisible}
            baseSlug={baseSlug}
          ></Navbar>
          {hasFeatureStory && (
            <FeatureStoryNavbar baseSlug={baseSlug}></FeatureStoryNavbar>
          )}
        </div>
        <div
          className={classnames(
            {
              "base-layout__content": true,
              "base-layout__content--feature": hasFeatureStory,
              "base-layout__content--feature--en": hasFeatureStory && isLangEN,
              "base-layout__content--feature--is5":
                hasFeatureStory && featureStories.length === 5,
              "base-layout__content--feature--is5--en":
                hasFeatureStory && featureStories.length === 5 && isLangEN,
            },
            className
          )}
          style={style}
        >
          {children}
        </div>
        <BackToTop></BackToTop>
        <Footer></Footer>
      </div>
    </>
  )
}

export default BaseLayout
